function Logo({ light = false }) {
  return (
    <span className="inline-flex items-center gap-3">
      <span className="grid h-9 w-9 grid-cols-2 gap-[3px]" aria-hidden="true">
        <i className="col-span-2 bg-clay" />
        <i className="bg-clay" />
        <i className="bg-brick" />
        <i className="col-span-2 bg-clay" />
      </span>
      <span className={`leading-none ${light ? 'text-white' : 'text-ink'}`}>
        <span className="block text-[19px] font-extrabold tracking-tight">
          US PAVER <span className="text-clay">CO.</span>
        </span>
        <span className="mt-1 block text-[8px] font-bold uppercase tracking-[0.26em] opacity-60">
          Paver installation
        </span>
      </span>
    </span>
  );
}

export default Logo;
